export type OnboardingCategory =
  | "apparel_accessories"
  | "home_garden"
  | "bags_luggage"
  | "health_beauty"
  | "electronics"
  | "other"

export interface OnboardingCategoryOption {
  icon: string
  label: string
  value: OnboardingCategory
}

export interface OnboardingRegionOption {
  label: string
  value: string
}

export const getCategoryOptions = (): OnboardingCategoryOption[] => [
  {
    icon: "👚",
    label: t("ApparelAccessories"),
    value: "apparel_accessories",
  },
  { icon: "🏠", label: t("HomeGarden"), value: "home_garden" },
  { icon: "👜", label: t("BagsLuggage"), value: "bags_luggage" },
  {
    icon: "💄",
    label: t("HealthBeauty"),
    value: "health_beauty",
  },
  {
    icon: "📱",
    label: t("Electronics"),
    value: "electronics",
  },
  { icon: "📦", label: t("Other"), value: "other" },
]

export type OnboardingCategoryShortLabel =
  | "Apparel"
  | "Home"
  | "Bags"
  | "Beauty"
  | "Electronics"
  | "Other"

export const categoryShortLabelMap: () => Record<
  OnboardingCategory,
  OnboardingCategoryShortLabel
> = () => ({
  apparel_accessories: t("Apparel") as OnboardingCategoryShortLabel,
  bags_luggage: t("Bags") as OnboardingCategoryShortLabel,
  electronics: t("Electronics_0") as OnboardingCategoryShortLabel,
  health_beauty: t("Beauty") as OnboardingCategoryShortLabel,
  home_garden: t("Home") as OnboardingCategoryShortLabel,
  other: t("Other") as OnboardingCategoryShortLabel,
})

export const getRegionOptions = (): OnboardingRegionOption[] => [
  { label: t("🇺🇸UnitedStates"), value: "us" },
  { label: t("🇬🇧UnitedKingdom"), value: "uk" },
  { label: t("🇪🇺EuropeanUnion"), value: "eu" },
  { label: t("🇦🇺AustraliaNz"), value: "au" },
  { label: t("OtherRegions"), value: "other" },
]

// 区域默认退货天数：US/AU/UK/Other = 30，EU = 14
export const regionDefaultDaysMap: Record<string, number> = {
  us: 30,
  uk: 30,
  eu: 14,
  au: 30,
  other: 30,
}

export const DEFAULT_RETURN_DAYS = 30

export const computeRegionDefaultDays = (regions: string[]): number => {
  if (!regions.length) return DEFAULT_RETURN_DAYS
  return regions.reduce(
    (max, region) =>
      Math.max(max, regionDefaultDaysMap[region] ?? DEFAULT_RETURN_DAYS),
    0,
  )
}

export interface OnboardingSolutionOption {
  value: number
  label: string
}

export const getSolutionOptions = (): OnboardingSolutionOption[] => [
  { value: 5, label: t("ExchangeItem") },
  { value: 3, label: t("ReplaceItem") },
  { value: 1, label: t("RefundToOriginalPayment") },
  { value: 7, label: t("RefundToStoreCredit") },
  { value: 2, label: t("RefundToStoreDiscount") },
  { value: 4, label: t("RefundToStoreGiftCard") },
]

export interface OnboardingReturnRuleTypeOption {
  label: string
  value: string
}

export const getReturnRuleTypeOptions =
  (): OnboardingReturnRuleTypeOption[] => [
    { label: t("OrderFulfillment"), value: "order_fulfillment" },
    { label: t("OrderDelivery"), value: "order_delivery" },
    { label: t("OrderCreated"), value: "order_created" },
  ]

export type OnboardingThemeColorPreset =
  | "black"
  | "blue"
  | "green"
  | "purple"
  | "pink"

export interface OnboardingThemeColorOption {
  bgClass: string
  hex: string
  textClass: string
  value: OnboardingThemeColorPreset
}

export const getThemeColorOptions = (): OnboardingThemeColorOption[] => [
  {
    bgClass: "bg-[#0B0D16]",
    hex: "#0B0D16",
    textClass: "text-[#0B0D16]",
    value: "black",
  },
  {
    bgClass: "bg-[#1274FF]",
    hex: "#1274FF",
    textClass: "text-[#1274FF]",
    value: "blue",
  },
  {
    bgClass: "bg-[#00AF00]",
    hex: "#00AF00",
    textClass: "text-[#00AF00]",
    value: "green",
  },
  {
    bgClass: "bg-[#A527FF]",
    hex: "#A527FF",
    textClass: "text-[#A527FF]",
    value: "purple",
  },
  {
    bgClass: "bg-[#F512A2]",
    hex: "#F512A2",
    textClass: "text-[#F512A2]",
    value: "pink",
  },
]
